/* eslint-disable no-shadow */
export enum DomainsApiProviders {
  Cloudflare = 'cloudflare',
  SearchConsole = 'search-console'
}
